import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import connectHeadBg from '../../../images/Group 1.png';
import bodyLeftBg from '../../../images/Vector 68.png';
import bodyRightBg from '../../../images/Vector 67.png';
import formBg from '../../../images/connect-bg.png';
import ContactForm from '../../Shared/ContactForm/ContactForm';
import './Connect.css'

const connectTextBg = {
    backgroundImage: `url(${connectHeadBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}
const connectLeftBg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left 2% bottom 25%',
    backgroundRepeat: 'no-repeat'
}
const connectRightBg = {
    backgroundImage: `url(${bodyRightBg})`,
    backgroundPosition: 'right 2% top 10%',
    backgroundRepeat: 'no-repeat'
}
const connectBg = {
    backgroundImage: `url(${formBg})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat'
}

const Connect = () => {
    return (
        <div style={connectLeftBg}>
            <Box sx={{ pb: 10 }} style={connectRightBg}>
                <Box style={connectBg}>
                    <Container sx={{ mt: 6 }}>
                        <Box style={connectTextBg} sx={{ textAlign: 'left' }}>
                            <Typography variant="h6" id="connect-start" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                                Let's Connect
                            </Typography>
                            <Typography variant="h3" id="connect-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                                How can we help you ?
                            </Typography>
                        </Box>
                    </Container>
                    <Box sx={{ pb: 10, pt: 5 }}>
                        <ContactForm />
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default Connect;